<h2 class="step-title">{{ title }}</h2>

<p class="step-subtitle">Take your best guess!</p>

<h3 class="slider-value">{{ sliderDisplay }}</h3>

<div class="slider-container">
  <input class="slider is-fullwidth is-circle is-large" type="range" (input)="slide($event); countVisitorAction();" [(value)]="sliderValue"
    min="0" [max]="sliderValues.length - 1" [sliderValue]="sliderValue" sliderProgress>
  <app-slider-label left="$60k" right="$5M"></app-slider-label>

  <div class="field">
    <div class="control">
      @if (inputModeTest) {
        <input
          inputmode="numeric"
          class="input is-large"
          value="{{ enterFieldValue }}"
          (focus)="beginAmountEdit()" (blur)="endAmountEdit()"
          (input)="setSlide($event); countVisitorAction();"
          type="number"
          [attr.aria-describedby]="showThousandsSuffix ? 'property-value-typed-amount' : null"
          maxlength="7"
          placeholder="or type amount"
          min="0"
          >
      }
      @if (!inputModeTest) {
        <input class="input is-large" value="{{ enterStringFieldValue }}" (input)="setSlide($event); countVisitorAction();"
          (focus)="beginAmountEdit()" (blur)="endAmountEdit()"
          [attr.aria-describedby]="showThousandsSuffix ? 'property-value-typed-amount' : null"
          type="text" inputmode="numeric" pattern="[0-9]*" placeholder="or type amount" digitOnly>
      }
      @if (showThousandsSuffix) {
        <div class="thousands-suffix" aria-hidden="true">K</div>
        <span id="property-value-typed-amount" class="is-sr-only">{{ typedAmountDescription }}</span>
      }
    </div>
  </div>
</div>

<button class="button continue is-large has-shadow-small" (click)="submit(sliderValue)">
  Continue
  <i class="fas fa-chevron-right"></i>
</button>
